import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, useTheme } from "@mui/material";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { itemListReduce } from "../../Helpers/Pages";
import { useMicrospecThemeLanguageContext } from "../../Themes";

const DrawerListChildrenItems = ({ data }) => {
    const theme = useTheme();
    const navigate = useNavigate()
    const location = useLocation();
    const { localizationProvider } = useMicrospecThemeLanguageContext();
    const { parent, childrenOpen } = data
    const itemsMap = useMemo(() => itemListReduce(parent.specs), [parent.specs]);
    return (
        <Collapse in={childrenOpen} timeout="auto" unmountOnExit>
            <List
                component="div"
                sx={{
                    marginInlineStart: 1,
                    marginInlineEnd: 0,
                    paddingInlineStart: 2,
                    paddingInlineEnd: 0,
                    my: 0,
                    py: 0
                }}
            >
                {
                    Object.values(itemsMap)
                        .filter(childItem => !childItem.hide)
                        .map((childItem) => {
                            const isSelected = childItem.fullPath === location.pathname;
                            return (
                                <ListItemButton
                                    key={childItem.path + "list-internal-item"}
                                    selected={isSelected}
                                    onClick={() => {
                                        if (childItem.fullPath !== location.pathname) {
                                            navigate(childItem.fullPath, { preventScrollReset: false })
                                        }
                                    }}
                                    sx={{
                                        borderRadius: '8px',
                                        my: 0.5,
                                        mx: 0.5,
                                        minHeight: 40,
                                        position: 'relative',
                                        transition: 'all 0.2s ease',

                                        // Background with theme colors
                                        background: isSelected
                                            ? (theme) => theme.palette.mode === 'dark'
                                                ? `${theme.palette.primary.main}26` // 15% opacity in hex
                                                : `${theme.palette.primary.main}1A` // 10% opacity in hex
                                            : 'transparent',

                                        // Border
                                        borderLeft: isSelected
                                            ? (theme) => `3px solid ${theme.palette.primary.main}`
                                            : '3px solid transparent',

                                        // Hover effects
                                        '&:hover': {
                                            background: isSelected
                                                ? (theme) => theme.palette.mode === 'dark'
                                                    ? `${theme.palette.primary.main}4D` // 30% opacity in hex
                                                    : `${theme.palette.primary.main}26` // 15% opacity in hex
                                                : (theme) => theme.palette.mode === 'dark'
                                                    ? 'rgba(255, 255, 255, 0.05)'
                                                    : 'rgba(0, 0, 0, 0.03)',
                                            transform: 'translateX(4px)',
                                        },

                                        // Active state
                                        '&:active': {
                                            transform: 'translateX(2px) scale(0.98)',
                                        },
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 36,
                                            color: isSelected
                                                ? (theme) => theme.palette.mode === 'dark'
                                                    ? theme.palette.primary.light
                                                    : theme.palette.primary.main
                                                : theme.palette.text.secondary,
                                            transition: 'all 0.2s ease',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 20,
                                            }
                                        }}
                                    >
                                        {childItem.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        id={childItem.path + "list-internal-item-text"}
                                        key={childItem.path + "list-internal-item-text"}
                                        name={childItem.path + "list-internal-item-text"}
                                        primary={localizationProvider.translateByType(childItem.name)}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            '& .MuiListItemText-primary': {
                                                fontSize: '0.85rem',
                                                fontWeight: isSelected ? 600 : 400,
                                                color: isSelected
                                                    ? theme.palette.text.primary
                                                    : theme.palette.text.secondary,
                                                transition: 'all 0.2s ease',
                                            }
                                        }}
                                    />

                                </ListItemButton>
                            )
                        })
                }
            </List>
        </Collapse>
    );
}

export default DrawerListChildrenItems;